export function tagsFromAccount(account: accountT): Array<{ id: string, value: string, providerKey: string }> {
  return account.tags;
}
